// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
/* eslint-disable */
const awsExportsDev = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://cw6o2fjjjbb2tcxnokk7y54j6u.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:983ce0f3-58e8-4067-8c41-a21b4e9209fe',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_CPe3uGz5h',
  'aws_user_pools_web_client_id': '6u1ft300i9hjpqqmejnbu7o8ot',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'mekenpo202610-backend-dev-mekenpob-private5ed30f02-bntcnck6pnch',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsMobileAppDev = {
  ...awsExportsDev,
  'aws_user_pools_web_client_id': '2o61fpllq2mq60sgt3tjdf5huj'
}

const awsExportsStg = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://kwy626uby5gqdjvrz5pfe7jaim.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:7976c42f-e73e-4deb-86e6-8f0ffabe5859',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_RgozOOMbH',
  'aws_user_pools_web_client_id': '2ebf34430acfvfensdopp45oji',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'mekenpo202610-backend-stg-mekenpob-private5ed30f02-u4tqxl0ltbxl',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsMobileAppStg = {
  ...awsExportsStg,
  'aws_user_pools_web_client_id': '1hpc4o1o2cmtb2ngj777hdm399'
}

const awsExportsProd = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://uzuoxearxne75n3maiay2h7rwe.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:390dd171-3fa2-4663-b665-ebabae6415de',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_f1cWUDUtK',
  'aws_user_pools_web_client_id': '3lt9q9fnhuu6tnt2fduarvbvi2',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'mekenpo202610-backend-prod-mekenpo-private5ed30f02-qoi5gvilpzyw',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsMobileAppProd = {
  ...awsExportsProd,
  'aws_user_pools_web_client_id': '5vugpgojr39elq3akugpglig4o'
}

export {
  awsExportsDev,
  awsExportsStg,
  awsExportsProd,
  awsExportsMobileAppDev,
  awsExportsMobileAppStg,
  awsExportsMobileAppProd
}
